import { create } from 'zustand'
import type { User } from '@vivilo/shared'

interface AuthState {
  user: (User & { is_admin: boolean }) | null
  hydrated: boolean
  setUser: (u: AuthState['user']) => void
  reset: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  hydrated: false,
  setUser: (u) => set({ user: u, hydrated: true }),
  reset: () => set({ user: null, hydrated: true }),
}))

if (typeof window !== 'undefined') {
  window.addEventListener('vv:auth-expired', () => useAuthStore.getState().reset())
}
